import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

// Layouts
import AdminLayout from "../layouts/AdminLayout";
import ReporterLayout from "../layouts/ReporterLayout";

// Pages
import Dashboard from "../components/pages/admin/Dashboard";
import ReporterDashboard from "../components/pages/reporter/ReporterDashboard";
import LoginPage from "../components/common/LoginPage";
import AddReporter from "../components/pages/admin/AddReporter";
import HeadlinePage from "../components/pages/admin/HeadlinePage";
import NewsManagement from "../components/pages/admin/NewsManagement";
import NewsCreationPage from "../components/pages/reporter/NewsCreationPage";
import ReportersListPage from "../components/pages/admin/ReportersListPage";
import SuperAdminLayout from "../layouts/SuperAdminLayout";
import SuperAdminDashboard from "../components/pages/superAdmin/SuperAdminDashboard";
import AdminPermission from "../components/pages/superAdmin/Adminpermission";
import CreateAdmin from "../components/pages/superAdmin/CreateAdmin";
import MyNews from "../components/pages/reporter/MyNews";
import CreateShort from "../components/pages/reporter/CreateShort";
import MyShorts from "../components/pages/reporter/MyShorts";
import PollForm from "../components/pages/admin/PollForm";
import PollList from "../components/pages/admin/PollList";

import VideoManagement from "../components/pages/admin/VideoManagement";
import TagManagement from "../components/pages/admin/TagManagement";
import CategoryManagement from "../components/pages/admin/CategoryManagement";
import SubCategoryManagement from "../components/pages/admin/SubCategoryManagement ";
import CategoryNewsForm from "../components/pages/admin/CategoryNewsForm";
import CreateNews from "../components/pages/admin/createNews";
import MyNewsAdmin from "../components/pages/admin/MyNewsAdmin";
import CreateStoryForm from "../components/pages/admin/CreateStoryForm";
import AdManagement from "../components/pages/admin/AdManagement";
import CompanyCategory from "../components/pages/admin/CompanyCategory";
import CompanySubCategory from "../components/pages/admin/CompanySubCategory";
import CompanyApproval from "../components/pages/admin/CompanyApproval";
import CategoryCompanyManagement from "../components/pages/admin/CategoryCompanyManagement";
import PendingCompanyProfileUpdatesPage from "../components/pages/admin/PendingCompanyProfileUpdatesPage";
import AdminProductManagementPage from "../components/pages/admin/AdminProductManagementPage";
import NewsPDFDownloader from "../components/pages/admin/NewsPDFDownloader";
import LiveNewsManager from "../components/pages/admin/LiveNewsManager";
import CreateShortadmin from "../components/pages/admin/CreateShortadmin";
import MyShortsList from "../components/pages/admin/MyShortsList";
import BulkDeleteNews from "../components/pages/admin/BulkDeleteNews";
import LocationManagement from "../components/pages/admin/LocationManagement";
import AllNewsManagement from "../components/pages/admin/AllNewsManagement";
import VideoManagementbyReporter from "../components/pages/reporter/VideoManagementbyReporter";
import MyShortsListbyReporter from "../components/pages/reporter/MyShortsListbyReporter";
import CreateStorybyReporter from "../components/pages/reporter/CreateStorybyReporter";
import AllVideosAdminManagement from "../components/pages/admin/AllVideosAdminManagement";
import AllShortsAdminManagement from "../components/pages/admin/AllShortsAdminManagement";
import AllStoryAdminManagement from "../components/pages/admin/AllStoryAdminManagement";
import ProfilePage from "../components/pages/admin/ProfilePage";




const RouterPage = () => {
  return (
   <Routes>
  <Route path="/" element={<LoginPage />} />
      
  {/* ✅ Admin Protected Route */}
  <Route element={<ProtectedRoute role="admin" />}>
    <Route element={<AdminLayout />}>
    <Route path="/profile" element={<ProfilePage />} />
      <Route path="/dashboard" element={<Dashboard />} />
   <Route path="add-reporter" element={<AddReporter/>} />
 
    <Route path="HeadlinePage" element={<HeadlinePage/>} />
    
               <Route path="/CreateShortadmin" element={<CreateShortadmin/>} />
                          <Route path="/MyShortsList" element={<MyShortsList/>} />
               
       <Route path="NewsManagement" element={<NewsManagement/>} />
       <Route path="reporters" element={<ReportersListPage/>} />
       
        <Route path="PollForm" element={<PollForm/>} />
        
           
        <Route path="PollList" element={<PollList/>} />
        
              <Route path="VideoManagement" element={<VideoManagement/>} />
              <Route path="TagManagement" element={<TagManagement />} />
              
                <Route path="CategoryManagement" element={<CategoryManagement />} />
                
                
                <Route path="SubCategoryManagement" element={<SubCategoryManagement />} />
                  <Route path="CategoryNewsForm" element={<CategoryNewsForm />} />
                     <Route path="/createNewsbyAdmin" element={<CreateNews/>} /> 
                     
                          <Route path="/MyNewsAdmin" element={<MyNewsAdmin/>} /> 
                          
                          <Route path="/CreateStoryForm" element={<CreateStoryForm/>} /> 
                          
                          <Route path="/AdManagement" element={<AdManagement/>} /> 
                          
                           <Route path="/CompanyCategory" element={<CompanyCategory/>} /> 
                           
                           <Route path="/CompanySubCategory" element={<CompanySubCategory/>} /> 
                           
                           <Route path="/CompanyApproval" element={<CompanyApproval/>} /> 
                           <Route path="/PendingCompanyProfileUpdatesPage" element={<PendingCompanyProfileUpdatesPage/>} /> 
                                
                                  <Route path="/AdminProductManagementPage" element={<AdminProductManagementPage/>} /> 
                           <Route path="/CategoryCompanyManagement" element={<CategoryCompanyManagement/>} /> 
                           <Route path="/NewsPDFDownloader" element={<NewsPDFDownloader/>} /> 
                               <Route path="/LiveNewsManager" element={<LiveNewsManager/>} /> 
                                 <Route path="/BulkDeleteNews" element={<BulkDeleteNews/>} /> 
                                      <Route path="/LocationManagement" element={<LocationManagement/>} /> 
                                 
                                 <Route path="/AllNewsManagement" element={<AllNewsManagement/>} />
                                 <Route path="/AllVideoManagement" element={<AllVideosAdminManagement/>} />
                                 <Route path="/AllShortsManagement" element={<AllShortsAdminManagement/>} />
                                 <Route path="/AllStoryManagement" element={<AllStoryAdminManagement/>} />
                               
                           
                           
                
    </Route>  
  </Route>

  {/* ✅ Reporter Protected Route */}
  <Route element={<ProtectedRoute role="reporter" />}>
    <Route element={<ReporterLayout />}>
      <Route path="/reporter-dashboard" element={<ReporterDashboard />} />
          <Route path="/NewsCreationPage" element={<NewsCreationPage/>} /> 
           <Route path="/MyNews" element={<MyNews/>} />
           
               <Route path="/create-short" element={<CreateShort/>} />
               
                <Route path="/MyShorts" element={<MyShortsListbyReporter/>} />
                <Route path="/CreateStorybyReporter" element={<CreateStorybyReporter/>} />
                
              <Route path="/VideoManagementbyReporter" element={<VideoManagementbyReporter/>} />
      
    </Route>
  </Route>

    {/* ✅ SuperAdmin Protected Routes */}
      <Route element={<ProtectedRoute role="superadmin" />}>
        <Route element={<SuperAdminLayout/>}>
          <Route path="/superadmin-dashboard" element={<SuperAdminDashboard/>} />
          <Route path="manage-admins" element={<AdminPermission/>} />

              <Route path="Create-admins" element={<CreateAdmin/>} />
          {/* aur bhi pages yahan add kar sakte ho */}
        </Route>
      </Route>


</Routes>

  );
};

export default RouterPage;
